// extracted by mini-css-extract-plugin
export var button = "_14-1";
export var featuredLink = "_14-4";
export var spinner = "_14-2";
export var spinnerContainer = "_14-3";
export var text = "_14-0";